<div class="contact-support">
    <div
        class="fixed z-20 top-0 right-0 left-0 pl-5 pr-6 h-12 bg-green-500 w-full flex items-center justify-between font-bold">
        <div class="text-white">Contact Support</div>
        <div>
            <p-button icon="pi pi-times" [rounded]="true" [text]="true" (click)="closeDialog()"
                class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
        </div>
    </div>
    <div class="space-y-4 p-4" [style]="{'padding-top': '4rem'}">
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <p class="text-gray-600 mb-6">We're here to help! Choose your preferred way to reach us.</p>

            <div class="contact-methods">
                <!-- Phone Support Section -->
                <div class="contact-section">
                    <div class="section-header">
                        <div class="icon">
                            <i class="pi pi-comment text-2xl text-green-500"></i>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-800 mb-2">Chat Support</h3>
                        <p class="text-gray-600">Chat directly with our support team</p>
                    </div>

                    <div class="phone-card">
                        <div class="phone-info">
                            <div class="phone-number">{{ supportPhone }}</div>
                            <div class="availability">Available 10:00 AM to 8:00 PM</div>
                        </div>
                        <button class="call-button" (click)="chatSupport()">
                            <span class="pi pi-comment"></span>
                            Chat Now
                        </button>
                    </div>
                </div>

                <!-- Email Support Section -->
                <div class="contact-section">
                    <div class="section-header">
                        <div class="icon">
                            <i class="pi pi-envelope text-2xl text-green-500"></i>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-800 mb-2">Email Support</h3>
                        <p class="text-gray-600">Send us a detailed message</p>
                    </div>

                    <form class="email-form" (ngSubmit)="submitEmailForm()">
                        <div class="form-group">
                            <label for="name">Name *</label>
                            <input type="text" id="name" name="name" [(ngModel)]="emailForm.name" (input)="clearError()"
                                placeholder="Your full name" required>
                        </div>

                        <div class="form-group">
                            <label for="email">Email *</label>
                            <input type="email" id="email" name="email" [(ngModel)]="emailForm.email"
                                (input)="clearError()" placeholder="your.email@example.com" required>
                        </div>

                        <div class="form-group">
                            <label for="subject">Subject *</label>
                            <input type="text" id="subject" name="subject" [(ngModel)]="emailForm.subject"
                                (input)="clearError()" placeholder="Brief description of your issue" required>
                        </div>

                        <div class="form-group">
                            <label for="message">Message *</label>
                            <textarea id="message" name="message" [(ngModel)]="emailForm.message" (input)="clearError()"
                                placeholder="Please describe your issue in detail..." rows="5" required></textarea>
                        </div>

                        <!-- Error Message -->
                        <div class="error-message" *ngIf="submitError">
                            {{ submitError }}
                        </div>

                        <!-- Success Message -->
                        <div class="success-message" *ngIf="submitSuccess">
                            Message sent successfully! We'll get back to you soon.
                        </div>

                        <button type="submit" class="submit-button" [disabled]="isSubmitting">
                            <span class="spinner" *ngIf="isSubmitting"></span>
                            {{ isSubmitting ? 'Sending...' : 'Send Message' }}
                        </button>
                    </form>
                </div>
            </div>

        </div>

        <!-- Additional Info -->
        <div class="additional-info">
            <h3>What to include in your message:</h3>
            <ul>
                <li>Your shopper ID or account details</li>
                <li>Specific details about the issue you're experiencing</li>
                <li>Any error messages if applicable</li>
                <li>Date and time when the issue occurred</li>
            </ul>
        </div>
    </div>
</div>